module.exports = __webpack_public_path__ + "img/Newbie_Bow_01_Warrior.02f7dcbc.png";